// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles_pagination__Xwmyy {
  font-family: "Open Sans";
  font-style: normal;
  font-size: 14px;
  line-height: 130%;
  position: relative;
  padding-left: 14px;
  border-top: 1px solid #eceff2;
  padding-top: 14px;
}
.styles_pagination__Xwmyy .styles_pages__GDWGn {
  position: relative;
  list-style: none;
  padding: 0;
  margin: 0;
  display: flex;
  align-items: center;
}
.styles_pagination__Xwmyy .styles_buttonPage__WP8qU {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  position: relative;
  background-color: transparent;
  outline: 0px;
  border: 1px solid #e3e7ed;
  border-radius: 38px;
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
  vertical-align: middle;
  appearance: none;
  text-decoration: none;
  border-radius: 16px;
  text-align: center;
  box-sizing: border-box;
  width: 34px;
  height: 34px;
  padding: 5px;
  margin: 0px 3px;
  color: rgba(0, 0, 0, 0.87);
  transition: color 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms, background-color 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;
}
.styles_pagination__Xwmyy .styles_buttonPage__WP8qU span {
  overflow: hidden;
  pointer-events: none;
  position: absolute;
  z-index: 0;
  inset: 0px;
  border-radius: inherit;
}

.styles_buttonPage__WP8qU.styles_active__jPoaF {
  color: #ffffff;
  background: #49a3a6;
}

.styles_buttonPage__WP8qU.styles_action__iiSGW {
  color: rgba(0, 0, 0, 0.87);
  padding: 7px;
  border: 1px solid rgba(255, 255, 255, 0);
  position: absolute;
  top: 0;
}
.styles_buttonPage__WP8qU.styles_action__iiSGW:hover {
  border: 1px solid #e3e7ed;
}
.styles_buttonPage__WP8qU.styles_action__iiSGW svg {
  width: 16px;
  height: 16px;
  fill: rgb(148, 150, 159);
}

.styles_buttonPage__WP8qU.styles_action__iiSGW.styles_prev__QEa9E {
  right: 41px;
  transform: rotate(180deg);
}

.styles_buttonPage__WP8qU.styles_action__iiSGW.styles_next__KQ9qu {
  right: 0;
}

.styles_buttonPage__WP8qU.styles_ellipsis__YRmoR,
.styles_buttonPage__WP8qU.styles_action__iiSGW.styles_locked__nUYGg,
.styles_buttonPage__WP8qU.styles_action__iiSGW.styles_locked__nUYGg {
  pointer-events: none;
}`, "",{"version":3,"sources":["webpack://./src/components/Pagination/styles.module.scss"],"names":[],"mappings":"AAAA;EACE,wBAAA;EACA,kBAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,kBAAA;EACA,6BAAA;EACA,iBAAA;AACF;AACE;EACE,kBAAA;EACA,gBAAA;EACA,UAAA;EACA,SAAA;EACA,aAAA;EACA,mBAAA;AACJ;AAEE;EACE,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,6BAAA;EACA,YAAA;EACA,yBAAA;EACA,mBAAA;EACA,eAAA;EACA,yBAAA;UAAA,iBAAA;EACA,sBAAA;EACA,gBAAA;EACA,qBAAA;EACA,mBAAA;EACA,kBAAA;EACA,sBAAA;EACA,WAAA;EACA,YAAA;EACA,YAAA;EACA,eAAA;EACA,0BAAA;EACA,iHAAA;AAAJ;AAGI;EACE,gBAAA;EACA,oBAAA;EACA,kBAAA;EACA,UAAA;EACA,UAAA;EACA,sBAAA;AADN;;AAMA;EACE,cAAA;EACA,mBAAA;AAHF;;AAMA;EACE,0BAAA;EACA,YAAA;EACA,wCAAA;EACA,kBAAA;EACA,MAAA;AAHF;AAKE;EACE,yBAAA;AAHJ;AAME;EACE,WAAA;EACA,YAAA;EACA,wBAAA;AAJJ;;AAOA;EACE,WAAA;EACA,yBAAA;AAJF;;AAOA;EACE,QAAA;AAJF;;AAOA;;;EAGE,oBAAA;AAJF","sourcesContent":[".pagination {\n  font-family: 'Open Sans';\n  font-style: normal;\n  font-size: 14px;\n  line-height: 130%;\n  position: relative;\n  padding-left: 14px;\n  border-top: 1px solid #eceff2;\n  padding-top: 14px;\n\n  .pages {\n    position: relative;\n    list-style: none;\n    padding: 0;\n    margin: 0;\n    display: flex;\n    align-items: center;\n  }\n\n  .buttonPage {\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    position: relative;\n    background-color: transparent;\n    outline: 0px;\n    border: 1px solid #e3e7ed;\n    border-radius: 38px;\n    cursor: pointer;\n    user-select: none;\n    vertical-align: middle;\n    appearance: none;\n    text-decoration: none;\n    border-radius: 16px;\n    text-align: center;\n    box-sizing: border-box;\n    width: 34px;\n    height: 34px;\n    padding: 5px;\n    margin: 0px 3px;\n    color: rgba(0, 0, 0, 0.87);\n    transition: color 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms,\n      background-color 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;\n\n    span {\n      overflow: hidden;\n      pointer-events: none;\n      position: absolute;\n      z-index: 0;\n      inset: 0px;\n      border-radius: inherit;\n    }\n  }\n}\n\n.buttonPage.active {\n  color: #ffffff;\n  background: #49a3a6;\n}\n\n.buttonPage.action {\n  color: rgba(0, 0, 0, 0.87);\n  padding: 7px;\n  border: 1px solid rgba(255, 255, 255, 0);\n  position: absolute;\n  top: 0;\n\n  &:hover {\n    border: 1px solid #e3e7ed;\n  }\n\n  svg {\n    width: 16px;\n    height: 16px;\n    fill: rgba(148, 150, 159, 1);\n  }\n}\n.buttonPage.action.prev {\n  right: 41px;\n  transform: rotate(180deg);\n}\n\n.buttonPage.action.next {\n  right: 0;\n}\n\n.buttonPage.ellipsis,\n.buttonPage.action.locked,\n.buttonPage.action.locked {\n  pointer-events: none;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"pagination": `styles_pagination__Xwmyy`,
	"pages": `styles_pages__GDWGn`,
	"buttonPage": `styles_buttonPage__WP8qU`,
	"active": `styles_active__jPoaF`,
	"action": `styles_action__iiSGW`,
	"prev": `styles_prev__QEa9E`,
	"next": `styles_next__KQ9qu`,
	"ellipsis": `styles_ellipsis__YRmoR`,
	"locked": `styles_locked__nUYGg`
};
export default ___CSS_LOADER_EXPORT___;
